"use client";

import React from "react";
import { Landmark } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const events = [{
  time: "4:00 PM",
  location: "CHIESA DI SANTO SPIRITO IN SASSIA",
  address: "Via dei Penitenzieri 12, 00193 Roma",
  title: "The Ceremony",
  description: "Join us for a Catholic ceremony in one of Rome's beautiful churches, just steps from St. Peter's.",
  descriptionIt: "Unitevi a noi per la cerimonia in una delle bellissime chiese di Roma, a pochi passi da San Pietro."
}, {
  time: "6:00 PM",
  location: "ROME CAVALIERI WALDORF ASTORIA",
  address: "Via Alberto Cadlolo 101, 00136 Roma",
  title: "Aperitivo",
  description: "Celebrate the start of the evening with prosecco, wine, and light bites at sunset.",
  descriptionIt: "Festeggiamo l'inizio della serata con prosecco, cocktail e stuzzichini al tramonto."
}, {
  time: "8:00 PM",
  location: "ROME CAVALIERI WALDORF ASTORIA",
  address: "Via Alberto Cadlolo 101, 00136 Roma",
  title: "Dinner",
  description: "Join us for a seated dinner under the Roman sky.",
  descriptionIt: "Unitevi a noi per una cena servita sotto il cielo di Roma."
}, {
  time: "To Follow",
  location: "ROME CAVALIERI WALDORF ASTORIA",
  address: "Via Alberto Cadlolo 101, 00136 Roma",
  title: "After Party",
  description: "Let the celebration continue with music, cocktails, and dancing into the night.",
  descriptionIt: "Continuiamo a festeggiare con musica, cocktail e balli fino a tarda notte."
}];
export default function TheCelebrationItinerary() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="the-celebration-itinerary" className="bg-background py-16 md:py-24 text-foreground overflow-hidden">
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <div className="mb-12 md:mb-20 text-center">

  {/* NEW DATE LINE */}

  <h2 className="mb-4 font-serif text-3xl sm:text-4xl md:text-5xl text-foreground">
    The Celebration Itinerary
  </h2>
          <p className="mx-auto max-w-2xl font-sans text-sm sm:text-base text-muted-foreground leading-relaxed">
            We have planned a beautiful day across some of our favorite locations in Rome.
          </p>
          <p className="mt-6 mb-3 font-sans text-[11px] sm:text-xs uppercase tracking-[0.3em] text-muted-foreground">
  Friday, September 11, 2026
</p>
        </div>

        <div ref={ref} className="relative">
          {/* timeline line */}
          <div className="absolute left-5 sm:left-6 md:left-1/2 top-0 bottom-0 -translate-x-1/2 w-px bg-border" />
          <div className={`absolute left-5 sm:left-6 md:left-1/2 top-0 bottom-0 -translate-x-1/2 w-px bg-primary origin-top transition-transform duration-[2000ms] ease-in-out ${isVisible ? "scale-y-100" : "scale-y-0"}`} />

          <div className="flex flex-col gap-10 md:gap-24">
            {events.map((event, i) => <div key={i} data-index={i} className={`relative flex w-full flex-col items-start md:flex-row md:items-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
            transitionDelay: `${i * 300}ms`
          }}>
                {/* left / time block */}
                <div className="mb-3 w-full pl-14 sm:pl-16 md:mb-0 md:w-1/2 md:pr-16 md:pl-0 md:text-right">
                  <div className="mb-1 font-serif text-xl sm:text-2xl text-primary">
                    {event.time}
                  </div>
                  <div className="font-sans text-[11px] sm:text-sm uppercase tracking-[0.18em] sm:tracking-widest text-muted-foreground leading-relaxed">
                    {event.location}
                  </div>
                  <a href={`https://maps.google.com/?q=${encodeURIComponent(event.address)}`} target="_blank" rel="noopener noreferrer" className="mt-1 block font-sans text-[11px] sm:text-xs text-muted-foreground/70 hover:text-primary transition-colors duration-200 leading-relaxed break-words">
                    {event.address}
                  </a>
                </div>

                {/* icon */}
                <div className="absolute left-5 sm:left-6 md:left-1/2 top-0 md:top-1/2 -translate-x-1/2 md:-translate-y-1/2 z-10 flex h-10 w-10 sm:h-11 sm:w-11 md:h-12 md:w-12 items-center justify-center rounded-full border border-primary bg-background text-primary shadow-sm">
                  <Landmark className="h-4 w-4 sm:h-5 sm:w-5" strokeWidth={1.5} />
                </div>

                {/* right / description block */}
                <div className="w-full pl-14 sm:pl-16 md:w-1/2 md:pl-16">
                  <h3 className="mb-2 md:mb-3 font-serif text-2xl sm:text-3xl text-foreground leading-tight">
                    {event.title}
                  </h3>
                  <p className="max-w-md font-sans text-sm sm:text-base leading-relaxed text-muted-foreground">
                    {event.description}
                  </p>
                  <p className="mt-2 max-w-md font-sans text-xs sm:text-sm italic leading-relaxed text-muted-foreground/70">
                    {event.descriptionIt}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}